import template from "./template.html";
import { GraphqlClient } from "../../../services/GraphqlClient";
import { Component, Input } from "angular-ts-decorators";
import {
  GetRosterForRegistrationDocument,
  GetRosterForRegistrationQuery,
  GetAttendanceForGameDocument,
  GetAttendanceForGameQuery,
  UpsertAttendanceToGameDocument,
  UpsertAttendanceToGameMutation
} from "../../../graphql/graphql";
import { ITeamRegistration } from "../../../models/ITeamRegistration";
import _, { add } from "lodash";
import { StateParams } from "@uirouter/angularjs";

@Component({
  selector: "stAttendance",
  template,
})
export class AttendanceComponent {
  static Name = "stAttendance";
  static $inject = ["GraphqlClient", "$stateParams", "$scope"];
  @Input() registration: ITeamRegistration;

  constructor(
    private client: GraphqlClient,
    public $stateParams: StateParams,
    private $scope: angular.IScope
  ) {}


  private roster?: GetRosterForRegistrationQuery["registration"]["rosters"];
  private gameAttendance?: GetAttendanceForGameQuery["game"]["attendance_records"];

  public rosterAttendanceMap?: ReturnType<AttendanceComponent["getGameAttendance"]>;

  async rosterEntries() {
    const response = await this.client.client
      .query(GetRosterForRegistrationDocument, {
        teamRegistrationId: this.registration.id,
      })
      .toPromise();

    const gameResponse = await this.client.client.query(
      GetAttendanceForGameDocument,
      { gameId: this.$stateParams.gameId }
    );
    this.roster = _.orderBy(response.data?.registration.rosters, [
      "player.lastName",
      "player.firstName",
    ]);

    this.gameAttendance = gameResponse.data?.game.attendance_records;
    this.rosterAttendanceMap = this.getGameAttendance();
    this.$scope.$apply();
  }

  private getGameAttendance() {
    const attendance = this.roster?.map((roster) => {
      const attendanceRecord = this.gameAttendance?.find(
        (record) => record.roster.id === roster.id
      );
      return {
        ...roster,
        attended: attendanceRecord?.attended || false,
        attendanceId: attendanceRecord?.id
      };
    });
    return attendance;
  }

  public async setAttendance(attendance: NonNullable<ReturnType<typeof this.getGameAttendance>>[number], attended: boolean) {
    const response = await this.client.client.mutation(UpsertAttendanceToGameDocument, {
      gameId: this.$stateParams.gameId,

      attendance: {
        id: attendance.attendanceId,
        attended,
        roster: attendance.id,
        registration: this.registration.id
      } 
    });
    const updatedRoster = this.rosterAttendanceMap?.find((record) => record.id === response.data?.upsert_attendance_to_game?.roster.id);
    if (updatedRoster) {
      updatedRoster.attended = response.data?.upsert_attendance_to_game?.attended ?? false;
      updatedRoster.attendanceId = response.data?.upsert_attendance_to_game?.id;
    }
    this.$scope.$apply();
  }

  /**
   * event handler for when the component and all child components are inited
   */
  $onInit() {
    this.rosterEntries();
  }
}
